export const LEGACY_EMAIL_DOMAIN = '@kztournament.local';

const isRealEmail = (e) => Boolean(e) && !e.endsWith(LEGACY_EMAIL_DOMAIN);

// The Firebase auth email is the source of truth — that's what the user signs in with.
// The profile doc's `email` field can be stale or set to an aspirational value that was
// never actually applied to the auth account, so ignore it here.
export const hasRealEmail = (_userProfile, firebaseUser) => {
  if (!firebaseUser) return true;
  return isRealEmail(firebaseUser.email);
};
